import RentingPreparationList from '@/components/RentingPreparation/RentingPreparationList'

let RentingPreparationRouter = [{
    path: '/renting_preparation',
    name: 'RentingPreparationList',
    component: RentingPreparationList,
    meta: {
      title: 'Préparations en cours',
      requiresAuth: true,
      authorizations: ['renting-preparation_index', 'desktop_access']
    }
  }
]

export default RentingPreparationRouter



// WEBPACK FOOTER //
// ./src/components/RentingPreparation/router.js